import { Component, inject } from '@angular/core';
import { ApiPoll, PollsApi } from '@tytapp/api';
import { ContentBlockViewComponent } from '@tytapp/content/content-block-view-component';
import { PetitionBlock } from './petition-block';
import { ContentModule } from '@tytapp/content';
import { PollsModule } from '../polls.module';


@Component({
    selector: 'tyt-petition-block',
    standalone: true,
    imports: [ ContentModule, PollsModule ],
    template: `
        @if (poll) {
          <tyt-poll [mini]="!block.full" [poll]="poll"></tyt-poll>
        }
        `
})
export class ViewComponent extends ContentBlockViewComponent<PetitionBlock> {
    private pollsApi = inject(PollsApi);

    poll: ApiPoll;

    async ngOnInit() {
        if (this.block.selectionMode === 'preview') {
            let petitions = await this.pollsApi.all('published', 'Petition').toPromise();
            this.poll = petitions[0];
        } else if (this.block.selectionMode === 'featured') {
            this.poll = await this.pollsApi.getFeaturedPetition().toPromise();
        } else if (this.block.selectionMode === 'id') {
            try {
                this.poll = await this.pollsApi.getPoll(this.block.petitionId).toPromise();
            } catch (e) {
                console.error(`[PetitionBlock] No such petition ${this.block.petitionId}`);
            }
        }
    }
}
